import QmCopy from './src/main'

/* istanbul ignore next */
QmCopy.install = function (Vue) {
  Vue.component(QmCopy.name, QmCopy)
}

export default QmCopy
